
import React, { useContext,  useState } from "react";
import { useNavigate} from "react-router-dom";
import { AuthContext } from "./AuthContext";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [login, setLoginOrRegister] = useState(true);
  const [loginError, setLoginError] = useState(false);

  const data = useContext(AuthContext);
  const navigate = useNavigate();
  const {setToken, backEnd, token} = data;
  
    function Send(event) {
      event.preventDefault();
  
      if (!username || !password) {
        alert("Please enter both email and password.");
        return;
      }
  
      const dataToSend = {
        username: username,
        password: password,
      };
  
      const endpoint = login ? "/login" : "/register";
      
      fetch(backEnd + endpoint, {
        withCredentials: true,
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data.token);
          console.log(token);

          if (data.response === "200") {
            console.log(data.token);
            setToken(data.token); // Assuming the token is returned in the response
            navigate("/catalogo");
          }
        })
        .catch((error) => {
          console.error("Error sending data to server:", error);
          setLoginError(true);
          setTimeout(() => {
            setLoginError(false); // Reset login error after 2 seconds
          }, 500); 
          console.log("feito");
          // Handle errors here, show an error message to the user, etc.
        });
  }

  return (
   
   <div className="centralize">
    <main className="form-signin w-25 m-auto mt-5 ">
      <a className="footer-link close" href="/">
        <i className="fa-solid fa-arrow-left"></i>
      </a>
  
      <form>
        <img
          className="mb-4"
          src="book-open-solid.svg"
          alt=""
          width="72"
          height="57"
        ></img>
        <h1 className="h3 mb-3 fw-normal">Please {login ?  "Sign in" :  "Sign Up"}</h1>

        <div className="form-floating">
        <label htmlFor="floatingInput">Email address</label>
          <input
            type="email"
            className="form-control"
            id="floatingInput"
            placeholder="name@example.com"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          
        </div>
      
        <label htmlFor="floatingPassword">Password</label>
        <div className="form-floating">
          <input
            type="password"
            className="form-control"
            id="floatingPassword"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
         
        </div>
        {!login ? <div className="form-floating">
        <label htmlFor="floatingPassword">Password</label>
          <input
            type="password"
            className="form-control"
            id="floatingPassword"
            placeholder="Confirm Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        :null}
        

        <div className="checkbox mb-3"></div>
        <button
          className={loginError ? "w-40 btn btn-lg m-4":"w-50 btn btn-lg m-4"}
          onClick={Send}
          type="submit"
        >
         {login ?  "Sign in" :  "Sign Up"}
        </button>
        <button className="w-25 btn btn-lg btn-primary m-2" type="submit">
          <i className="fa-brands fa-google"></i>
        </button>
       
          <button onClick={(event)=>{event.preventDefault();
              login  ? setLoginOrRegister(false) : setLoginOrRegister(true); 
          }}>{!login ?  "Login" :  "Register"}</button>

      </form>
    </main>
  </div>
    
  );
}

export default Login;
